module.exports = __webpack_public_path__ + "img/exclamation-triangle-red.4f94a832.svg";